// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"d9aa76a2","140":"6ef1a33f","453":"a492ffeb"}[chunkId] + ".chunk.js";
};